import React, { useState, useEffect } from 'react';
import { FaInstagram, FaTiktok, FaAmazon } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";

// Importar las imágenes con las rutas correctas
import coverImage from '../../../assets/images/7sm/cover.png';
import pagesImage from '../../../assets/images/jdm-tecnicas/paginas.png';

import UrlConfig from '../../../data/UrlConfig'; // <<-- ADJUST THIS PATH TO YOUR UrlConfig.js FILE
import Common from '../../../common/Common';
import { sendCodedLog } from '../../../services/logService';
import { useLocation } from 'react-router-dom';

const API_URLS = UrlConfig; // Assuming UrlConfig is an object directly or a function that returns an object.


// Component for the Purchase Flow Popup
const PurchaseFlowPopup = ({ isOpen, onClose, onSubmit, formData, handleChange, isLoading, error, currentStep, setCurrentStep }) => {
  
  const location = useLocation();
  if (!isOpen) return null;

  const handleNextStep = () => {
    if (!formData.selectedFormat) {
      alert('Please select a format before proceeding.');
      return;
    }
    setCurrentStep('enterDetails');

    sendCodedLog({
      message: 'En Modal Quiero Mi libro => enterDetails',
      event: '7sm_want_book_en_enterDetails',
        ...Common.getCommonLogData(location)
    });
  };

  const handleBackStep = () => {
    setCurrentStep('selectFormat');

    sendCodedLog({
      message: 'En Modal Quiero Mi libro => handleBackStep',
      event: '7sm_want_book_en_handleBackStep',
        ...Common.getCommonLogData(location)
    });
  };

  const handleFinalSubmit = (e) => {
    e.preventDefault();
    onSubmit(e, formData.selectedFormat);
    
    sendCodedLog({
      message: 'En Modal Quiero Mi libro => handleFinalModalSubmit | selectedFormat: ' + formData.selectedFormat,
      event: '7sm_want_book_en_handleFinalSubmit',
        ...Common.getCommonLogData(location)
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-900 rounded-2xl shadow-lg border border-gray-700 p-8 max-w-md w-full relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white text-2xl font-bold"
        >
          &times;
        </button>
        <h2 className="text-2xl font-semibold text-center mb-4">
          I Want My Manifestation Book!
        </h2>

        {currentStep === 'selectFormat' && (
          <div className="flex flex-col gap-5">
            <p className="text-gray-300 text-center mb-4">
              Select the format you desire for the book:
            </p>
            <div className="flex flex-col gap-3">
              <label className="flex items-center space-x-3 text-white cursor-pointer bg-gray-800 p-3 rounded-lg border border-gray-700 hover:border-purple-500 transition">
                <input
                  type="radio"
                  name="selectedFormat"
                  value="ebook"
                  checked={formData.selectedFormat === 'ebook'}
                  onChange={handleChange}
                  className="form-radio text-purple-500 h-5 w-5"
                />
                <span>Ebook (Digital)</span>
              </label>
              <label className="flex items-center space-x-3 text-white cursor-pointer bg-gray-800 p-3 rounded-lg border border-gray-700 hover:border-purple-500 transition">
                <input
                  type="radio"
                  name="selectedFormat"
                  value="paperback"
                  checked={formData.selectedFormat === 'paperback'}
                  onChange={handleChange}
                  className="form-radio text-purple-500 h-5 w-5"
                />
                <span>Paperback (Physical)</span>
              </label>
              <label className="flex items-center space-x-3 text-white cursor-pointer bg-gray-800 p-3 rounded-lg border border-gray-700 hover:border-purple-500 transition">
                <input
                  type="radio"
                  name="selectedFormat"
                  value="hardcover"
                  checked={formData.selectedFormat === 'hardcover'}
                  onChange={handleChange}
                  className="form-radio text-purple-500 h-5 w-5"
                />
                <span>Hardcover (Physical)</span>
              </label>
            </div>
            <button
              onClick={handleNextStep}
              className="mt-6 py-3 rounded-lg font-semibold transition text-lg bg-gradient-to-r from-purple-600 to-pink-600 hover:opacity-90"
            >
              Next
            </button>
          </div>
        )}

        {currentStep === 'enterDetails' && (
          <form onSubmit={handleFinalSubmit} className="flex flex-col gap-5">
            <p className="text-gray-300 text-center mb-2">
              Please enter your details to continue:
            </p>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              className="px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white focus:outline-none focus:border-purple-500"
              required
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your Email"
              className="px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white focus:outline-none focus:border-purple-500"
              required
            />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Your Phone (optional)"
              className="px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white focus:outline-none focus:border-purple-500"
            />
            <button
              type="submit"
              className={`mt-2 py-3 rounded-lg font-semibold transition text-lg
                ${isLoading ? 'bg-gray-600 cursor-not-allowed' : 'bg-gradient-to-r from-purple-600 to-pink-600 hover:opacity-90'}`}
              disabled={isLoading}
            >
              {isLoading ? 'Processing...' : 'Payment Method & Delivery'}
            </button>
            <button
              type="button"
              onClick={handleBackStep}
              className="mt-2 py-3 rounded-lg font-semibold transition text-lg bg-gray-700 hover:bg-gray-600 text-white"
            >
              Back to select format
            </button>
          </form>
        )}
        {error && <p className="text-red-500 text-center mt-4">{error}</p>}
      </div>
    </div>
  );
};


// NEW: Component for the Success Message Popup
const SuccessMessagePopup = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-900 rounded-2xl shadow-lg border border-gray-700 p-8 max-w-md w-full relative text-center">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white text-2xl font-bold"
        >
          &times;
        </button>
        <h2 className="text-3xl font-semibold text-green-400 mb-4">
          Thank you for your interest!
        </h2>
        <p className="text-gray-300 text-lg mb-6">
          {message}
        </p>
        <button
          onClick={onClose}
          className="mt-4 py-3 px-6 rounded-lg font-semibold transition text-lg bg-gradient-to-r from-purple-600 to-pink-600 hover:opacity-90"
        >
          Got It
        </button>
      </div>
    </div>
  );
};


const SevenStepManifestationBookEn = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", selectedFormat: "" });
  const [showPurchasePopup, setShowPurchasePopup] = useState(false);
  const [showSuccessMessagePopup, setShowSuccessMessagePopup] = useState(false); // New state for the success modal
  const [successMessageContent, setSuccessMessageContent] = useState(''); // New state for the success message content
  const [currentPurchaseStep, setCurrentPurchaseStep] = useState('selectFormat');
  const [timeLeft, setTimeLeft] = useState({});
  const launchDate = new Date('2025-11-11T00:00:00Z');

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(''); // Error will be shown in the PurchaseFlowPopup
  const location = useLocation();

  let iwantmybookClick = () => {
    setShowPurchasePopup(true);
    setCurrentPurchaseStep('selectFormat'); // Ensure it starts on the first step
    setError(''); // Clear errors when opening the popup

    sendCodedLog({
      message: 'Le dio click a quiero mi libro en ingles',
      event: '7sm_want_book_en',
        ...Common.getCommonLogData(location)
    });
  };

  useEffect(() => {
    // Recupera los datos del localStorage
    const storedName = localStorage.getItem('track_user_name') || '';
    const storedEmail = localStorage.getItem('track_user_email') || '';
    // Solo actualiza si hay algo guardado
    if (storedName || storedEmail) {
      setFormData(prev => ({
        ...prev,
        name: storedName || prev.name,
        email: storedEmail || prev.email,
      }));
    }
  }, []);

  const calculateTimeLeft = () => {
    const difference = +launchDate - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0, launched: true };
    }
    return timeLeft;
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError(''); // Clear errors when changing fields
  };

  const handleSubmit = async (e, selectedFormat) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    formData.name && localStorage.setItem('track_user_name', formData.name);
    formData.email.trim() && localStorage.setItem('track_user_email', formData.email.trim());
    
    sendCodedLog({
      message: 'En Modal Nombre e Email y Tel => handleSubmit',
      event: '7sm_want_book_en_handleSubmit',
        ...Common.getCommonLogData(location)
    });

    // Basic frontend validation
    if (!formData.name.trim() || !formData.email.trim()) {
      setError('Please enter your name and email.');
      setIsLoading(false);

      sendCodedLog({
        message: 'En Modal Nombre e Email y Tel => Please enter your name and email',
        event: '7sm_want_book_en_nameError',
          ...Common.getCommonLogData(location)
      });

      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError('Please enter a valid email address.');
      setIsLoading(false);

      sendCodedLog({
        message: 'En Modal Nombre e Email y Tel => Please enter a valid email address',
        event: '7sm_want_book_en_emailError',
          ...Common.getCommonLogData(location)
      });

      return;
    }
    if (!selectedFormat) {
        setError('A book format has not been selected.');
        setIsLoading(false);

        sendCodedLog({
          message: 'En Modal Nombre e Email y Tel => A book format has not been selected.',
          event: '7sm_want_book_en_bookFormatError',
            ...Common.getCommonLogData(location)
        });

        return;
    }

    try {
      const newsletterValue = `book_manifestation_${selectedFormat}`; // Changed from journal_manifestation_

      const response = await fetch(API_URLS.leads_action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: formData.email,
          nick: formData.name,
          phone: formData.phone,
          folder: 'seven-step-manifestation-book',
          page: 'BookLaunchPage', // Changed from JournalLaunchPage
          section: 'purchase_flow',
          status: 'BookInterest', // Changed from JournalInterest
          product_format: selectedFormat,
          newsletter: [newsletterValue]
        }),
      });

      sendCodedLog({
        message: 'En Modal Nombre e Email y Tel => add_lead_call',
        event: '7sm_want_book_en_add_lead_call',
          ...Common.getCommonLogData(location)
      });

      const data = await response.json();

      if (response.ok) {

        sendCodedLog({
          message: 'En Modal Nombre e Email y Tel => add_lead_call_ok_response',
          event: '7sm_want_book_en_add_lead_call_ok_response',
            ...Common.getCommonLogData(location)
        });

        setSuccessMessageContent('Thank you for your interest! I will contact you to coordinate delivery of your book.'); // Updated success message
        setFormData({ name: "", email: "", phone: "", selectedFormat: "" }); // Reset form
        setShowPurchasePopup(false); // Close the purchase modal
        setShowSuccessMessagePopup(true); // Open the success modal
        setCurrentPurchaseStep('selectFormat'); // Reset the purchase modal step for next time
      } else {
        throw new Error(data.message || 'An error occurred while processing your request.');
      }
    } catch (err) {

      sendCodedLog({
        message: 'En Modal Nombre e Email y Tel => add_lead_call_ERROR_response | ' + err.message,
        event: '7sm_want_book_en_add_lead_call_ERROR_response',
          ...Common.getCommonLogData(location)
      });

      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  // --- NEW HANDLER FUNCTIONS FOR SOCIAL MEDIA LINKS ---
  const handleSocialMediaClick = (platform, url) => {
    sendCodedLog({
      message: `Click en enlace de red social: ${platform}`,
      event: `7sm_social_media_click_${platform.toLowerCase()}_en`,
      ...Common.getCommonLogData(location)
    });
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleInstagramClick = (e) => {
    e.preventDefault(); // Prevent default link behavior
    handleSocialMediaClick('Instagram', 'https://instagram.com/quantum.gus');
  };

  const handleTiktokClick = (e) => {
    e.preventDefault(); // Prevent default link behavior
    handleSocialMediaClick('TikTok', 'https://www.tiktok.com/@quantum.gus');
  };

  const handleYoutubeClick = (e) => {
    e.preventDefault(); // Prevent default link behavior
    handleSocialMediaClick('YouTube', 'https://www.youtube.com/@imanifesti');
  };

  // If you later decide to add Amazon, you can use a similar handler
  /*
  const handleAmazonClick = (e) => {
    e.preventDefault();
    handleSocialMediaClick('Amazon', 'https://www.amazon.com');
  };
  */
  // --- END NEW HANDLER FUNCTIONS ---

  // --- NEW HANDLER FUNCTIONS FOR IMAGE CLICKS ---
  const handleCoverImageClick = () => {
    sendCodedLog({
      message: 'Click en imagen de portada del libro',
      event: '7sm_cover_cover_image_click_en',
      ...Common.getCommonLogData(location)
    });
    // Puedes añadir aquí cualquier otra acción si es necesario,
    // como abrir la imagen en un modal más grande o navegar a una URL.
  };

  const handlePagesImageClick = () => {
    sendCodedLog({
      message: 'Click en imagen de páginas interiores del libro',
      event: '7sm_pages_pages_image_click_en',
      ...Common.getCommonLogData(location)
    });
    // Igual que con la imagen de portada, puedes añadir otras acciones.
  };
  // --- END NEW HANDLER FUNCTIONS FOR IMAGE CLICKS ---


  return (
    <div className="bg-black text-white min-h-screen font-sans flex flex-col">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-950 via-black to-gray-900 opacity-95"></div>

      <main className="relative z-10 flex-grow container mx-auto px-6 lg:px-20 py-12 flex flex-col items-center max-w-7xl">
        <h1 className="text-3xl sm:text-4xl font-bold mb-4 text-center lg:text-5xl">
          The Seven Steps of Manifestation ✨
        </h1>
        {/* Image Section */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8 mb-8 w-full max-w-6xl">
          <div className="w-full max-w-md lg:w-2/5 flex flex-col items-center">
            <img
              src={coverImage}
              alt="The Seven Steps of Manifestation Book Cover"
              className="rounded-xl shadow-2xl border border-gray-700 object-cover w-full cursor-pointer" // Added cursor-pointer
              onClick={handleCoverImageClick} // Added onClick handler
            />
            {/* Subtitle below the cover image */}
            <p className="text-gray-400 max-w-xs text-center mt-6 text-base sm:text-lg lg:text-xl">
              A guide designed to align your vision, desire, and belief.
              Discover the most effective techniques to manifest your purpose.
            </p>
          </div>

          <img
            src={pagesImage}
            alt="Inside pages of The Seven Steps of Manifestation Book"
            className="w-full max-w-3xl lg:w-3/5 rounded-xl shadow-2xl border border-gray-700 object-contain cursor-pointer" // Added cursor-pointer
            onClick={handlePagesImageClick} // Added onClick handler
          />
        </div>

        <h1 className="text-3xl sm:text-4xl font-bold mb-4 text-center lg:text-5xl">
          Preview
        </h1>
        {/* FlipHTML5 Preview - COMMENTED OUT */}
        {/*
        <div className="w-full max-w-5xl mb-14 shadow-2xl rounded-2xl overflow-hidden border border-gray-700">
          <div style={{ position: "relative", paddingTop: "max(60%,324px)", width: "100%", height: 0 }}>
            <iframe
              style={{ position: "absolute", border: "none", width: "100%", height: "100%", left: 0, top: 0 }}
              src="https://online.fliphtml5.com/siete-llaves/mdsd/"
              seamless="seamless"
              scrolling="no"
              frameBorder="0"
              allowTransparency={true}
              allowFullScreen={true}
              title="Book Preview"
            ></iframe>
          </div>
        </div>
        */}

        {/* Book Benefits */}
        <div className="max-w-3xl text-center mb-10">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-center lg:text-5xl">
            What you will achieve with this Book
          </h2>
          <ul className="text-gray-300 space-y-3 text-lg">
            <li>• Clarity in your vision</li>
            <li>• Ignite your desire</li>
            <li>• Strengthen your belief</li>
            <li>• Practice acceptance</li>
            <li>• Create conscious intention</li>
            <li>• Take action</li>
            <li>• Learn to let go (detachment)</li>
          </ul>
        </div>

        {/* You can uncomment the countdown if you want */}
        {/* {timeLeft.launched ? (
          <p className="text-xl font-bold text-green-400 mb-8">The Book is now available!</p>
        ) : (
          <div className="text-center mb-8 bg-gray-900/50 p-6 rounded-xl border border-gray-700">
            <p className="text-gray-300 text-lg mb-4">Official launch: Only!</p>
            <div className="flex justify-center items-center space-x-4">
              <div className="flex flex-col items-center">
                <span className="text-4xl font-bold text-purple-400">{timeLeft.days || '0'}</span>
                <span className="text-sm text-gray-400">Days</span>
              </div>
              <span className="text-4xl font-bold text-gray-500">:</span>
              <div className="flex flex-col items-center">
                <span className="text-4xl font-bold text-purple-400">{timeLeft.hours || '0'}</span>
                <span className="text-sm text-gray-400">Hours</span>
              </div>
              <span className="text-4xl font-bold text-gray-500">:</span>
              <div className="flex flex-col items-center">
                <span className="text-4xl font-bold text-purple-400">{timeLeft.minutes || '0'}</span>
                <span className="text-sm text-gray-400">Minutes</span>
              </div>
              <span className="text-4xl font-bold text-gray-500">:</span>
              <div className="flex flex-col items-center">
                <span className="text-4xl font-bold text-purple-400">{timeLeft.seconds || '0'}</span>
                <span className="text-sm text-gray-400">Seconds</span>
              </div>
            </div>
          </div>
        )} */}

        {/* "I Want My Book" button that triggers the purchase popup */}
        <button
          onClick={() => iwantmybookClick()}
          className="px-8 py-4 bg-yellow-500 text-black font-semibold rounded-lg shadow-lg hover:bg-yellow-400 transition text-xl mb-16"
        >
          I Want My Book
        </button>
      </main>

      {/* Footer with Social Media */}
      <footer className="relative z-10 text-center py-8 text-sm text-gray-600 flex flex-col items-center">
        <div className="flex justify-center gap-8 text-3xl text-gray-400 mb-4">
          <a onClick={handleInstagramClick} className="hover:text-white cursor-pointer" title="Instagram">
            <FaInstagram />
          </a>
          <a onClick={handleTiktokClick} className="hover:text-white cursor-pointer" title="TikTok">
            <FaTiktok />
          </a>
          <a onClick={handleYoutubeClick} className="hover:text-white cursor-pointer" title="YouTube">
            <FaYoutube />
          </a>
          {/* <a onClick={handleAmazonClick} className="hover:text-white cursor-pointer" title="Amazon">
            <FaAmazon />
          </a> */}
        </div>
        © {new Date().getFullYear()} Gus • Aguiar | On a mission to elevate and transform.
      </footer>

      {/* Purchase Flow Popup */}
      <PurchaseFlowPopup
        isOpen={showPurchasePopup}
        onClose={() => {
            setShowPurchasePopup(false);
            setCurrentPurchaseStep('selectFormat'); // Reset step when closing the popup
            setFormData(prev => ({ ...prev, selectedFormat: "" })); // Clear selected format
            setError(''); // Clear errors
        }}
        onSubmit={handleSubmit}
        formData={formData}
        handleChange={handleChange}
        isLoading={isLoading}
        error={error} // Pass the error for the popup to display
        currentStep={currentPurchaseStep}
        setCurrentStep={setCurrentPurchaseStep}
      />

      {/* NEW: Success Message Popup */}
      <SuccessMessagePopup
        isOpen={showSuccessMessagePopup}
        onClose={() => setShowSuccessMessagePopup(false)}
        message={successMessageContent}
      />
    </div>
  );
};

export default SevenStepManifestationBookEn;